// @ts-strict-ignore
import { useEffect, useState } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { ProductButtons } from '@/widgets/ProductButtons/ProductButtons'

import { BASE_URL } from '@/shared/lib/const/env'
import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { scrollObserver } from '@/shared/lib/utils/scroll/scrollObserver'
import { OrderType, ProductControl } from '@/shared/types/product-types'
import { Image } from '@/shared/ui/Image'
import { ProductPrice } from '@/shared/ui/product/ProductPrice'

import { TotalProductSet } from '../product-price-widget/MUST_BE_REFACTORED/TotalProductSet/TotalProductSet'

import cl from './product-page-fixed-panel.module.scss'

/** Product info with buy button in the bottom panel.
 *
 * */
export const ProductPageFixedPanel = (): JSX.Element => {
	const { product } = useProduct()
	const { isMobile } = useMediaQueries()
	const [isHidden, setIsHidden] = useState<boolean>(true)
	const [isReadyForDeviceDetect, setIsReadyForDeviceDetect] = useState<boolean>(false)

	const observerHandler: IntersectionObserverCallback = observer => {
		setIsHidden(observer[0].isIntersecting)
	}

	useEffect(() => {
		if (isMobile) {
			setIsHidden(false)
			setIsReadyForDeviceDetect(true)
			return
		}

		setIsReadyForDeviceDetect(true)

		return scrollObserver({ nodeId: `productTitle`, observerHandler, rootMargin: 0 })
	}, [isMobile])

	const imgSrc = product.IMAGES[0] || product.IMAGE

	const isPriceVisible = product.VISIBLE_PRICE && !product.CONTROL?.includes(ProductControl.HidePrice)
	const isBuyHidden = product.CONTROL?.includes(ProductControl.HideBuy)
	const hiddenClass = isReadyForDeviceDetect && !isMobile && isHidden ? cl['productBottomPanel--hidden'] : ''
	const panelClassName = `${cl.productBottomPanel} ${hiddenClass}`.trim()

	if (!isPriceVisible && isBuyHidden) return null

	return (
		<section className={panelClassName}>
			<div className={cl.productBottomPanel__deskWrap}>
				<div className={cl.productBottomPanel__content}>
					{/** Image */}
					{!!imgSrc && (
						<div className={cl.productBottomPanel__imageWrap}>
							<Image alt={product.TITLE} src={BASE_URL + imgSrc} width={50} height={50} />
						</div>
					)}
					<div className={cl.productBottomPanel__info}>
						{/** Title */}
						<p
							className={cl.productBottomPanel__title}
							dangerouslySetInnerHTML={createMarkup(`Купить ${product.TITLE}`)}
						/>

						{/** Price */}
						{isPriceVisible && (
							<div className={cl.productBottomPanel__price}>
								<ProductPrice
									is_archive={product.ORDER_TYPE === OrderType.Archive}
									price={product.PRICE}
									oldPrice={product.OLD_PRICE}
									flat
									revert
								/>
								<div className={cl.productBottomPanel__totalProductSet}>
									<TotalProductSet />
								</div>
							</div>
						)}
					</div>
					{!isBuyHidden && (
						<div className={cl.productBottomPanel__desktopButton}>
							<ProductButtons productInfo={product} isProductPage hideFastOrder buttonSize="M" />
						</div>
					)}
				</div>
			</div>

			<div className={cl.productBottomPanel__mobWrap}>
				{isPriceVisible && (
					<div className={cl.productBottomPanel__price}>
						<ProductPrice
							is_archive={product.ORDER_TYPE === OrderType.Archive}
							price={product.PRICE}
							oldPrice={product.OLD_PRICE}
							flat
							revert
						/>
						<TotalProductSet hidePrice />
					</div>
				)}

				{!isBuyHidden && <ProductButtons productInfo={product} />}
			</div>
		</section>
	)
}
